(() => {
  function initCarousel(root: HTMLElement) {
    const track = root.querySelector('[data-carousel-track]') as HTMLElement | null;
    const prev = root.querySelector('[data-carousel-prev]') as HTMLButtonElement | null;
    const next = root.querySelector('[data-carousel-next]') as HTMLButtonElement | null;
    const indicator = root.querySelector('[data-carousel-indicator]') as HTMLElement | null;
    if (!track || !prev || !next || !indicator) return;

    const items = Array.from(track.querySelectorAll('[data-carousel-item]')) as HTMLElement[];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;

    function updateAccessibility() {
      const carouselControlsVisible = getComputedStyle(prev.parentElement!).display !== 'none';
      items.forEach((item, itemIndex) => {
        const inactive = carouselControlsVisible && itemIndex !== current;
        item.toggleAttribute('inert', inactive);
        if (inactive) item.setAttribute('aria-hidden', 'true');
        else item.removeAttribute('aria-hidden');
      });
    }

    function updateState(index: number) {
      current = index;
      indicator.textContent = `${current + 1} / ${items.length}`;
      prev.disabled = current === 0;
      next.disabled = current === items.length - 1;
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === current));
      updateAccessibility();
    }

    function goTo(index: number, animate = true) {
      const nextIndex = Math.max(0, Math.min(index, items.length - 1));
      updateState(nextIndex);
      track.scrollTo({
        left: items[nextIndex].offsetLeft - track.offsetLeft,
        behavior: animate && !reduceMotion.matches ? 'smooth' : 'auto',
      });
    }

    prev.addEventListener('click', () => goTo(current - 1));
    next.addEventListener('click', () => goTo(current + 1));

    track.addEventListener('scroll', () => {
      let closest = 0;
      let minimumDistance = Infinity;
      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (distance < minimumDistance) {
          minimumDistance = distance;
          closest = index;
        }
      });
      if (closest !== current) updateState(closest);
    });

    window.addEventListener('resize', updateAccessibility);

    goTo(0, false);
  }

  function init() {
    document.querySelectorAll<HTMLElement>('[data-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
